/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { OutagesComponent } from './components/outages.component';
import { OutagesFilterComponent } from './components/outagesfilter.component';
import { OutagesRoutingModule } from './outages-routing.module';
import { CurrentOutagesComponent } from './components/cur-outageslist.component';
import { OutagesService } from './services/outages.service';
import { DataTablesModule } from 'angular-datatables';
import { ItemsModule } from '../items/items.module';
import { ServiceItemsModule } from '../serviceitems/serviceitems.module';
import { PlannedOutagesComponent } from './components/planned-outageslist.component';
import { PlannedOutagesDetailContainerComponent } from './components/planned-outagesdetailcontainer.component';
import { RelatedPlannedOutagesComponent } from './components/relatedplanned-outages.component';
import { PlannedOutagesDetailComponent } from './components/planned-outagesdetail.component';
import { PlannedOutageDetailService } from './services/planned-outagesdetail.service';
import { EllipsisModule } from 'ngx-ellipsis';
import { RelatedPlannedOutagesService } from './services/relatedplanned-outages.service';
import { SpinnerModule } from '../../../shared/spinner/spinner.module';
import { InfiniteScrollModule } from '../shared/module/infinite-scroll.module';

@NgModule({
    imports:  [
        SharedModule,
        OutagesRoutingModule,
        DataTablesModule,
        ItemsModule,
        ServiceItemsModule,
        EllipsisModule,
        SpinnerModule,
        InfiniteScrollModule
    ],
    declarations: [
        OutagesComponent,
        OutagesFilterComponent,
        CurrentOutagesComponent,
        PlannedOutagesComponent,
        PlannedOutagesDetailContainerComponent,
        RelatedPlannedOutagesComponent,
        PlannedOutagesDetailComponent
    ],
    providers: [
        OutagesService,
        PlannedOutageDetailService,
        RelatedPlannedOutagesService
    ],
    exports: [
        OutagesComponent
    ]
})

export class OutagesModule { }
